import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export const DeleteCustomerDialog = ({ visible, customer, onHide, onConfirm }) => {
  const footer = (
    <React.Fragment>
      <Button label="No" icon="pi pi-times" className="p-button-text" onClick={onHide} />
      <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={onConfirm} />
    </React.Fragment>
  );

  return (
    <Dialog 
      visible={visible} 
      className="w-full md:w-25rem"
      header="Confirm" 
      modal 
      footer={footer} 
      onHide={onHide}
    >
      <div className="flex align-items-center p-4">
        <i className="pi pi-exclamation-triangle text-5xl text-orange-500 mr-3 align-middle" />
        {customer && <span className="text-lg">Are you sure you want to delete <b>{customer.name}</b>?</span>}
      </div>
    </Dialog>
  );
};
